module.exports = __webpack_public_path__ + "img/es.284ebab3.svg";